import React from 'react';

function BackgroundLines() {
  return (
    <div className="mi-bglines">
      <div className="quantum-grid"></div>
      <div className="quantum-orb quantum-orb--1"></div>
      <div className="quantum-orb quantum-orb--2"></div>
      <div className="quantum-orb quantum-orb--3"></div>
    </div>
  );
}

export default BackgroundLines;
